import React from 'react';
import MovieCastContainer from './MovieCastContainer.js';

const App = () => {
    return (
      <section className="container">
        <MovieCastContainer/>
      </section>
    );
  }

export default App;